var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{ref:"table",attrs:{"service":_vm.EmailScheduleService,"entity":_vm.entity,"columns":_vm.columns,"disablePermissionChecks":true,"operations":"add,refresh,delete"},scopedSlots:_vm._u([{key:"subject",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.subject)+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }